<ui-card
    class="image-toggle-container"
    [class.disabled]="disabled"
    [class.checked]="checked"
    [class.loading]="isLoading"
    variant="outline"
    [withMargin]="false"
    [withSpacing]="false"
>
    @if (src) {
        @if (src.endsWith('.svg')) {
            <app-svg-image [url]="src" />
        } @else {
            <img [src]="src" />
        }
    }
    <label *ngIf="label" for="id">{{ label | translate }}</label>
    <mat-slide-toggle
        *ngIf="!hideToggle"
        [id]="id"
        color="primary"
        disableRipple
        hideIcon
        [(ngModel)]="checked"
        [disabled]="!!disabled"
    />
    <ng-content />
</ui-card>
